// * A workaround for radix dialog sheets catching focus after any type of select field gains focus...
export function onBlurWorkaround(event: React.FocusEvent<HTMLElement>) {
  const element = event.relatedTarget as HTMLElement
  if (element && (element.tagName === 'A' || element.tagName === 'BUTTON' || element.tagName === 'INPUT' || element.tagName === 'TEXTAREA')) {
    element.focus()
  }
}
